import { useState, useEffect } from "react"
import { Content } from "./layout/Content/Content"
import { NavMenu } from "./layout/NavMenu/NavMenu"
import style from "./PageAbout.module.scss"

const { pageAbout, content } = style

export const PageAbout = () => {
	const [menuItemIndex, setMenuItemIndex] = useState(() => {
		return window.location.hash ? 1 : 0
	})

	// Handle hash change to switch menu item
	useEffect(() => {
		const handleHashChange = () => {
			if (window.location.hash) {
				setMenuItemIndex(1)
			}
		}

		window.addEventListener("hashchange", handleHashChange)
		return () => window.removeEventListener("hashchange", handleHashChange)
	}, [])

	const switchMenuItemHandle = (index: number) => {
		setMenuItemIndex(index)
	}

	return (
		<section className={pageAbout}>
			<NavMenu listItemHandle={switchMenuItemHandle} menuItemIndex={menuItemIndex} />
			<div className={content}>
				<Content menuItemIndex={menuItemIndex} />
			</div>
		</section>
	)
}
